import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import AccordionForm from '../Accordion/AccordionForm';
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import Province from 'components/blocks/Delta/Inputs/Province';
import FormInputText from '../Inputs/FormInputTexto';
import FormInputIPF from '../Inputs/FormInputIPF';
import get from 'lodash/get';
import FormInputFecha from '../Inputs/FormInputFecha';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { Modal } from 'react-bootstrap';

interface ITitleProps {
    title?: string;
    text?: string;
}

interface IInputProps {
    emailVisible?: boolean
    activarIRPF?: boolean;
    activarEstadoCivil?: boolean;
    validarMinimoIRPF?: boolean;
    activarSS?: boolean;
    activarFechaNacimiento?: boolean
    activarNumerosDireccion?: boolean
    activarNacionalidad?: boolean
    activarEmpresaNombre?: boolean
    activarEmpresaCCC?: boolean
    title?: string | ITitleProps
    children?: React.ReactNode
}

const FormDatosPersonales: React.FC<IInputProps> = ({
    emailVisible = false,
    activarIRPF = false,
    activarEstadoCivil = false,
    validarMinimoIRPF = false,
    activarSS = false,
    activarFechaNacimiento = false,
    activarNumerosDireccion = false,
    activarNacionalidad = false,
    activarEmpresaNombre = false,
    activarEmpresaCCC = false,
    title,
    children
}) => {
    //METODO PARA REGISTRAR TODOS LOS DATOS DEL USUARIO

    const { register, formState: { errors }, setValue, watch } = useFormContext();

    const watchProvincia = watch("DatosPersonales.SolicitanteProvincia");
    const watchProvinciaDesc = watch("DatosPersonales.SolicitanteProvinciaDescripcion");
    const watchComm = watch("DatosPersonales.SolicitanteComunidadCodigo");
    const watchCommDesc = watch("DatosPersonales.SolicitanteComunidadCodigoDescripcion");
    const [showSolicitanteIRPFModal, setShowSolicitanteIRPFModal] = useState(false);

    // Determinar ancho dinámico según qué campos estén activos
    const activeCount = [activarIRPF, activarEstadoCivil, activarSS, activarNacionalidad, activarEmpresaNombre, activarEmpresaCCC].filter(Boolean).length;
    const colSize = activeCount === 1 ? 12 : 6;
    let activeIndex = 0;
    let activeIndex2 = 0;
    const activos = [emailVisible, activarFechaNacimiento].filter(Boolean).length;
    const sizeColumn = activos === 2 ? 6 : 12;
    const defaultAccordionTitle = 'Datos Personales';
    const defaultAccordionModal = 'Si necesita actualizar cualquier dato que aparezca en esta sección, acceda al apartado de Ajustes de Usuario, donde podrá revisar, editar y guardar de forma segura su información personal, datos de contacto y preferencias. Una vez realizados los cambios, asegúrese de guardar la configuración para que se reflejen correctamente en su perfil.';
    const accordionTitle = typeof title === 'string' ? title : title?.title || defaultAccordionTitle;
    const accordionModal = typeof title === 'string' ? defaultAccordionModal : title?.text || defaultAccordionModal;

    const getColumnDistribution = (count: number): number[] => {
        switch (count) {
            case 1:
                return [12];
            case 2:
                return [6, 6];
            case 3:
                return [4, 4, 4];
            case 4:
                return [6, 6, 6, 6];
            case 5:
                return [6, 6, 4, 4, 4];
            case 6:
                return [6, 6, 4, 4, 4, 4];
            default:
                return [];
        }

    };

    return (
        <>
            <AccordionForm title={accordionTitle} expandedInit={false} nombreError='DatosPersonales' modal={accordionModal} >
                <div className="row">
                    <div className="col-xl-12">
                        <FieldsetContainer legend={accordionTitle} disabled={false}>
                            <FormInputText
                                name='DatosPersonales.SolicitanteNombre'
                                id='DatosPersonales.SolicitanteNombre'
                                label='Nombre'
                                md={4}
                                xl={4}
                                disabled={true}
                            />
                            <FormInputText
                                name='DatosPersonales.SolicitanteApellido1'
                                id='DatosPersonales.SolicitanteApellido1'
                                label='Apellido 1'
                                md={4}
                                xl={4}
                                disabled={true}
                            />
                            <FormInputText
                                name='DatosPersonales.SolicitanteApellido2'
                                id='DatosPersonales.SolicitanteApellido2'
                                label='Apellido 2'
                                md={4}
                                xl={4}
                                disabled={true}
                            />
                            <FormInputIPF
                                name={'DatosPersonales.SolicitanteIPF'}
                                id={'DatosPersonales.SolicitanteIPF'}
                                label={'IPF (Identificación Personal Fisica)'} placeholder={''}
                                md={6}
                                xl={6}
                                disabled={true}
                            />
                            <FormInputText
                                name='DatosPersonales.SolicitanteTelefono'
                                id='DatosPersonales.SolicitanteTelefono'
                                label='Telefono Móvil'
                                md={3}
                                xl={3}
                                maxLength={9}
                                pattern={/^[0-9]{9}$/}
                                patternMessage='El teléfono debe contener 9 dígitos numéricos'
                                disabled={true}
                            />
                            <FormInputText
                                name='DatosPersonales.SolicitanteFijo'
                                id='DatosPersonales.SolicitanteFijo'
                                label='Teléfono Fijo'
                                md={3}
                                xl={3}
                                maxLength={9}
                                pattern={/^[0-9]{9}$/}
                                patternMessage='El teléfono debe contener 9 dígitos numéricos'
                                disabled={true}
                            />
                            {emailVisible && (
                                <FormInputText
                                    name='DatosPersonales.SolicitanteEmail'
                                    id='DatosPersonales.SolicitanteEmail'
                                    label='Email'
                                    md={sizeColumn}
                                    xl={sizeColumn}
                                    disabled={true}
                                    readonly={true}
                                />
                            )}

                            {activarFechaNacimiento && (
                                <FormInputFecha
                                    name='DatosPersonales.SolicitanteFechaNacimiento'
                                    id='DatosPersonales.SolicitanteFechaNacimiento'
                                    label='Fecha de Nacimiento'
                                    placeholder=''
                                    md={sizeColumn}
                                    xl={sizeColumn}
                                    col={12}
                                    maxDate={new Date()}
                                    disableDate={true}
                                />
                            )}

                            <FormInputText
                                name='DatosPersonales.SolicitanteDomicilio'
                                id='DatosPersonales.SolicitanteDomicilio'
                                label='Domicilio (Calle/Plaza/Avenida/...)'
                                md={6}
                                xl={6}
                                disabled={true}
                            />

                            <FormInputText
                                name='DatosPersonales.SolicitanteCodigoPostal'
                                id='DatosPersonales.SolicitanteCodigoPostal'
                                label='Código Postal'
                                md={6}
                                xl={6}
                                maxLength={5}
                                pattern={/^[0-9]{1,5}$/}
                                patternMessage='El código postal debe contener solo dígitos y como máximo 5 caracteres'
                                disabled={true}
                            />
                            {
                                activarNumerosDireccion && (
                                    <>
                                        <FormInputText
                                            name='DatosPersonales.SolicitanteNumero'
                                            id='DatosPersonales.SolicitanteNumero'
                                            label='Numero'
                                            md={3}
                                            xl={3}
                                            disabled={true}
                                        />
                                        <FormInputText
                                            name='DatosPersonales.SolicitanteBloque'
                                            id='DatosPersonales.SolicitanteBloque'
                                            label='Bloque'
                                            md={2}
                                            xl={2}
                                            disabled={true}
                                        />
                                        <FormInputText
                                            name='DatosPersonales.SolicitanteEscalera'
                                            id='DatosPersonales.SolicitanteEscalera'
                                            label='Escalera'
                                            md={2}
                                            xl={2}
                                            disabled={true}
                                        />
                                        <FormInputText
                                            name='DatosPersonales.SolicitantePiso'
                                            id='DatosPersonales.SolicitantePiso'
                                            label='Piso'
                                            md={2}
                                            xl={2}
                                            disabled={true}
                                        />
                                        <FormInputText
                                            name='DatosPersonales.SolicitantePuerta'
                                            id='DatosPersonales.SolicitantePuerta'
                                            label='Puerta'
                                            md={3}
                                            xl={3}
                                            disabled={true}
                                        />
                                    </>
                                )
                            }
                            <div className="col-xl-6 col-md-6">
                                <Province
                                    errors={errors}
                                    register={register}
                                    idCode={'DatosPersonales.SolicitanteProvincia'}
                                    watchProvinceDescription={watchProvinciaDesc}
                                    idDescription={'DatosPersonales.SolicitanteProvinciaDescripcion'}
                                    watchProvinceCode={watchProvincia}
                                    setValue={setValue}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-xl-6 col-md-6">
                                <TestCommunity
                                    errors={errors}
                                    register={register}
                                    setValue={setValue}
                                    watchProvinceCode={watchProvincia}
                                    watchCommunityCode={watchComm}
                                    watchCommunityDescription={watchCommDesc}
                                    idCode={'DatosPersonales.SolicitanteComunidadCodigo'}
                                    idDescription={'DatosPersonales.SolicitanteComunidadCodigoDescripcion'}
                                    filterByProvince={true}
                                    disabled={true}
                                />
                            </div>

                            {activarSS && (
                                <FormInputText
                                    name='DatosPersonales.SolicitanteNumeroSS'
                                    id='DatosPersonales.SolicitanteNumeroSS'
                                    label='Número de Seguridad Social'
                                    md={getColumnDistribution(activeCount)[activeIndex++]}
                                    xl={getColumnDistribution(activeCount)[activeIndex2++]}
                                    maxLength={12}
                                    pattern={/^[0-9]{12}$/}
                                    patternMessage='Debe contener exactamente 12 dígitos numéricos'
                                    disabled={true}
                                />
                            )}
                            {
                                activarNacionalidad && (
                                    <FormInputText
                                        name='DatosPersonales.SolicitanteNacionalidad'
                                        id='DatosPersonales.SolicitanteNacionalidad'
                                        label='Nacionalidad'
                                        md={getColumnDistribution(activeCount)[activeIndex++]}
                                        xl={getColumnDistribution(activeCount)[activeIndex2++]}
                                        disabled={false}
                                    />
                                )
                            }
                            {
                                activarEmpresaNombre && (
                                    <FormInputText
                                        name='DatosPersonales.SolicitanteEmpresa'
                                        id='DatosPersonales.SolicitanteEmpresa'
                                        label='Empresa'
                                        md={getColumnDistribution(activeCount)[activeIndex++]}
                                        xl={getColumnDistribution(activeCount)[activeIndex2++]}
                                        disabled={false}
                                    />
                                )
                            }
                            {
                                activarEmpresaCCC && (
                                    <FormInputText
                                        name='DatosPersonales.SolicitanteCCC'
                                        id='DatosPersonales.SolicitanteCCC'
                                        label='CCC'
                                        md={getColumnDistribution(activeCount)[activeIndex++]}
                                        xl={getColumnDistribution(activeCount)[activeIndex2++]}
                                        disabled={false}
                                        pattern={/^[0-9]+$/}
                                        patternMessage='Debe poner solo numeros'
                                    />
                                )
                            }
                            {
                                activarEstadoCivil && (
                                    <FormInputText
                                        name='DatosPersonales.SolicitanteEstadoCivil'
                                        id='DatosPersonales.SolicitanteEstadoCivil'
                                        label='Estado Civil'
                                        md={getColumnDistribution(activeCount)[activeIndex++]}
                                        xl={getColumnDistribution(activeCount)[activeIndex2++]}
                                        disabled={false}
                                    />
                                )
                            }
                            {activarIRPF && (
                                <div className={`col-xl-${getColumnDistribution(activeCount)[activeIndex++]} col-md-${getColumnDistribution(activeCount)[activeIndex2++]}`}>
                                    <div className={`input-block ${errors && get(errors, 'DatosPersonales.SolicitanteIRPF')?.message ? 'error' : ''}`}>

                                        <div className="d-flex align-items-center justify-content-start">
                                            <label htmlFor="DatosPersonales.SolicitanteIRPF" className="input-block__label m-0">
                                                IRPF (%)
                                            </label>
                                            <TooltipComponent content="Mas Informacion">
                                                <div
                                                    onClick={() => setShowSolicitanteIRPFModal(true)}
                                                    className="information-icon-orange p-0 ms-2"
                                                />
                                            </TooltipComponent>
                                        </div>

                                        <input
                                            type="text"
                                            name="DatosPersonales.SolicitanteIRPF"
                                            id="DatosPersonales.SolicitanteIRPF"
                                            maxLength={6}
                                            {...register('DatosPersonales.SolicitanteIRPF', {
                                                setValueAs: (v) => {
                                                    const str = typeof v === 'string' ? v.trim() : String(v ?? '');
                                                    if (/^[0-9]+([.,][0-9]+)?$/.test(str)) {
                                                        return parseFloat(str.replace(',', '.')); // convierte a float
                                                    }
                                                    return v; // deja el valor original si no es numérico
                                                },
                                                pattern: {
                                                    value: /^[0-9]+([.,][0-9]{1,2})?$/,
                                                    message: 'Debe ser un número válido con hasta 2 decimales (use "." o ",")',
                                                },
                                                validate: validarMinimoIRPF
                                                    ? (value: any) => {
                                                        const rawValue = typeof value === 'string' ? value.trim() : value;
                                                        if (rawValue === '' || rawValue === null || rawValue === undefined) {
                                                            return true;
                                                        }

                                                        const numericValue = typeof rawValue === 'number'
                                                            ? rawValue
                                                            : parseFloat(String(rawValue).replace(',', '.'));

                                                        if (Number.isNaN(numericValue)) {
                                                            return true;
                                                        }

                                                        return numericValue >= 2 || 'El valor debe ser mayor o igual que 2';
                                                    }
                                                    : undefined,
                                            })}
                                        />

                                        {get(errors, 'DatosPersonales.SolicitanteIRPF')?.message && (
                                            <p className="error m-0">{get(errors, 'DatosPersonales.SolicitanteIRPF')?.message as any}</p>
                                        )}

                                        <Modal show={showSolicitanteIRPFModal} onHide={() => setShowSolicitanteIRPFModal(false)}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>IRPF (%)</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                 Tipo IRPF voluntario (superior al obligatorio según normativa fiscal)
                                            </Modal.Body>
                                        </Modal>
                                    </div>
                                </div>
                            )}

                            {
                                children && (
                                <>
                                    {children}
                                </>
                                )
                            }


                        </FieldsetContainer>
                    </div>
                </div>


            </AccordionForm>
        </>
    )
}

export default FormDatosPersonales;
